<template>
  <v-card
    ><v-card-title class="text-h5"
      >{{ $_haiiText("activeInfo") }}
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="auto">
          <v-card flat class="basic-info-child">
            <v-card-title>Overview </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <div class="d-flex">
                    <div class="mr-5">
                      <p>{{ $_haiiText("revisitRate") }}</p>
                      <p class="text-h5 font-weight-bold black--text">0 %</p>
                      <p>
                        <span class="text--accent-3 teal--text text-subtitle-1"
                          >0%
                          <v-icon color="teal accent-3" class="mb-1"
                            >mdi-arrow-up</v-icon
                          ></span
                        >
                        {{ $_haiiText("exDayRateUpAndDown") }}
                      </p>
                    </div>
                    <v-avatar
                      size="56"
                      color="#E1F5FE"
                      class="align-self-center"
                    >
                      <v-icon color="#00B0FF"> mdi-percent-outline</v-icon>
                    </v-avatar>
                  </div>
                </v-col>
                <v-col>
                  <div class="d-flex">
                    <div class="mr-5">
                      <p>{{ $_haiiText("useAveragePerPerson") }}</p>
                      <p class="text-h5 font-weight-bold black--text">0 min</p>
                      <p>
                        <span class="text--accent-3 teal--text text-subtitle-1"
                          >0%
                          <v-icon color="teal accent-3" class="mb-1"
                            >mdi-arrow-up</v-icon
                          ></span
                        >
                        {{ $_haiiText("exMonthRateUpAndDown") }}
                      </p>
                    </div>
                    <v-avatar
                      size="56"
                      color="#E1F5FE"
                      class="align-self-center"
                    >
                      <v-icon color="#00B0FF">
                        mdi-account-multiple-outline</v-icon
                      >
                    </v-avatar>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card flat class="basic-info-child">
            <v-card-title>{{ $_haiiText("dau") }} (DAU) </v-card-title>
            <v-card-text v-show="mountFlag">
              <v-row justify="end">
                <v-col cols="3">
                  <DatePicker
                    clearable
                    v-model="date"
                    :label="$_haiiText('testDate')"
                    @change="onSearch"
                    range
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <ApexChart
                    type="bar"
                    :options="apexChart.options"
                    :series="apexChart.series"
                    :height="chartHeight"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import ApexChart from "vue-apexcharts";
import { ApexChartInterface } from "@/components/defaultLayout/dashboard/DashboardBasicInfo.vue";
import DatePicker from "@/components/defaultLayout/util/DatePicker.vue";
import {
  StatisticsDauResponse,
  StatisticsListResponse,
} from "@/generated/adminapi";

@Component({
  components: {
    DatePicker,
    ApexChart,
  },
})
export default class ActiveInfo extends Vue {
  @Prop() dateRange: [string, string];
  @Prop() statisticsListResponse: StatisticsListResponse;

  mountFlag = false;
  date = [];

  mounted(): void {
    this.mountFlag = true;
    this.date = this.dateRange;
  }

  get chartHeight(): number {
    return window.innerHeight * 0.3;
  }

  get apexChart(): ApexChartInterface {
    let data = [];
    if (this.statisticsListResponse.daus) {
      // 시간 순서대로 sort
      const items = Object.keys(this.statisticsListResponse.daus).map(
        (value) => {
          return [value, this.statisticsListResponse.daus[value]];
        }
      );

      items.sort(
        (
          first: [number, StatisticsDauResponse],
          second: [number, StatisticsDauResponse]
        ) => {
          return first[1].historyCTS - second[1].historyCTS;
        }
      );

      const sortData = items.map((value) => value[1]);

      // data 에 할당
      data = sortData.map((data) => {
        return {
          x: this.$_haii.datetime.toYYMMDD(data.historyCTS),
          y: data.dau,
        };
      });
    }

    return {
      series: [
        {
          name: "Inflation",
          data: data,
        },
      ],
      options: {
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: "top", // top, center, bottom
            },
          },
        },

        dataLabels: {
          enabled: true,
          // formatter: function (val) {
          //   return val;
          // },
          offsetY: -30,
          style: {
            fontSize: "12px",
            colors: ["#304758"],
          },
        },
        yaxis: {
          max: 8,
          labels: {
            formatter(val: number, opts?: any): string | string[] {
              return Math.round(val) + "";
            },
          },
        },
      },
    };
  }

  dataHandle(value: any[]): any[] {
    if (!value) return [""];
    return value;
  }

  async onSearch(): Promise<void> {
    try {
      this.$emit("fetchData", this.date);
    } catch (e) {
      this.$_errorMessage(e);
    }
  }
}
</script>
<style scoped></style>
